import styled from './avaliacao.module.css';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import { useState } from 'react';
import { Alerta } from '../../utils/functions';
import api from '../../services/api';

function Avaliacao() {
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;


    const [scala, setScala] = useState(0);
    const [avalia1, setAvalia1] = useState(0);
    const [avalia2, setAvalia2] = useState(0);
    const [avalia3, setAvalia3] = useState(0);
    const [avalia4, setAvalia4] = useState(0);
    const [avalia5, setAvalia5] = useState(0);
    const [melhoria, setMelhoria] = useState('');
    const [nome, setNome] = useState('');
    const [cargo, setCargo] = useState('');
    const [autoriza, setAutoriza] = useState(false);


    function handleCheck() {
        setAutoriza(!autoriza);
    }

    function Salvar() {
        let dados = {
            cgccli: cgccli,
            avarec: scala,
            notcon: avalia1,
            notass: avalia2,
            notcom: avalia3,
            notset: avalia4,
            notent: avalia5,
            desava: melhoria,
            nomava: nome,
            carava: cargo,
            autinf: 1
        }



        if (autoriza == true) {

        } else {
            Alerta('Informação', 'Necessário autorizar uso das informações!', 'info');
            return;
        }

        if (nome != '') {

        } else {
            Alerta('Informação', 'Necessário preencher nome completo!', 'info');
            return;
        }

        if (cargo != '') {

        } else {
            Alerta('Informação', 'Necessário preencher cargo atual!', 'info');
            return;
        }


        api.post(`avaliacao/post`, dados)
            .then((response) => {

                if (response.data.result) {
                    setAutoriza(false);
                    setAvalia1(0);
                    setAvalia2(0);
                    setAvalia3(0);
                    setAvalia4(0);
                    setAvalia5(0);
                    setMelhoria('');
                    setNome('');
                    setCargo('');
                    Remclasses();
                    RemoveTodas();

                    Alerta('Sucesso', 'Dados enviados com sucesso!', 'success');
                } else {
                    Alerta('Erro', response.data.errocod, 'error');
                }

            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })

    }

    function RemoveTodas() {
            const element = document.querySelector('#consultorvetor1');
            element.classList.remove(styled.itemactive);

            const element1 = document.querySelector('#consultorvetor2');
            element1.classList.remove(styled.itemactive);

            const element2 = document.querySelector('#consultorvetor3');
            element2.classList.remove(styled.itemactive);

            const element3 = document.querySelector('#assistenciavetor1');
            element3.classList.remove(styled.itemactive);

            const element4 = document.querySelector('#assistenciavetor2');
            element4.classList.remove(styled.itemactive);

            const element5 = document.querySelector('#assistenciavetor3');
            element5.classList.remove(styled.itemactive);

            const element6 = document.querySelector('#canaisvetor1');
            element6.classList.remove(styled.itemactive);

            const element7 = document.querySelector('#canaisvetor2');
            element7.classList.remove(styled.itemactive);

            const element8 = document.querySelector('#canaisvetor3');
            element8.classList.remove(styled.itemactive);

            const element9 = document.querySelector('#setorvetor1');
            element9.classList.remove(styled.itemactive);

            const element10 = document.querySelector('#setorvetor2');
            element10.classList.remove(styled.itemactive);

            const element11 = document.querySelector('#setorvetor3');
            element11.classList.remove(styled.itemactive);

            const element12 = document.querySelector('#entregavetor1');
            element12.classList.remove(styled.itemactive);

            const element13 = document.querySelector('#entregavetor2');
            element13.classList.remove(styled.itemactive);

            const element14 = document.querySelector('#entregavetor3');
            element14.classList.remove(styled.itemactive);

            const element15 = document.querySelector('#check');
            element15.checked = false;


    }


    function Remclasses() {
        const element = document.querySelector('#a');
        element.classList.remove(styled.itemactive);

        const element1 = document.querySelector('#b');
        element1.classList.remove(styled.itemactive);

        const element2 = document.querySelector('#c');
        element2.classList.remove(styled.itemactive);

        const element3 = document.querySelector('#d');
        element3.classList.remove(styled.itemactive);

        const element4 = document.querySelector('#e');
        element4.classList.remove(styled.itemactive);

        const element5 = document.querySelector('#f');
        element5.classList.remove(styled.itemactive);

        const element6 = document.querySelector('#g');
        element6.classList.remove(styled.itemactive);

        const element7 = document.querySelector('#h');
        element7.classList.remove(styled.itemactive);

        const element8 = document.querySelector('#i');
        element8.classList.remove(styled.itemactive);

        const element9 = document.querySelector('#j');
        element9.classList.remove(styled.itemactive);
    }

    function RemclassesAvalia(wclasse) {
        if (wclasse.substring(0, 9) == 'consultor') {
            const element = document.querySelector('#consultorvetor1');
            element.classList.remove(styled.itemactive);

            const element1 = document.querySelector('#consultorvetor2');
            element1.classList.remove(styled.itemactive);

            const element2 = document.querySelector('#consultorvetor3');
            element2.classList.remove(styled.itemactive);
        }

        if (wclasse.substring(0, 11) == 'assistencia') {
            const element3 = document.querySelector('#assistenciavetor1');
            element3.classList.remove(styled.itemactive);

            const element4 = document.querySelector('#assistenciavetor2');
            element4.classList.remove(styled.itemactive);

            const element5 = document.querySelector('#assistenciavetor3');
            element5.classList.remove(styled.itemactive);
        }

        if (wclasse.substring(0, 6) == 'canais') {
            const element3 = document.querySelector('#canaisvetor1');
            element3.classList.remove(styled.itemactive);

            const element4 = document.querySelector('#canaisvetor2');
            element4.classList.remove(styled.itemactive);

            const element5 = document.querySelector('#canaisvetor3');
            element5.classList.remove(styled.itemactive);
        }

        if (wclasse.substring(0, 5) == 'setor') {
            const element3 = document.querySelector('#setorvetor1');
            element3.classList.remove(styled.itemactive);

            const element4 = document.querySelector('#setorvetor2');
            element4.classList.remove(styled.itemactive);

            const element5 = document.querySelector('#setorvetor3');
            element5.classList.remove(styled.itemactive);
        }

        if (wclasse.substring(0, 7) == 'entrega') {
            const element3 = document.querySelector('#entregavetor1');
            element3.classList.remove(styled.itemactive);

            const element4 = document.querySelector('#entregavetor2');
            element4.classList.remove(styled.itemactive);

            const element5 = document.querySelector('#entregavetor3');
            element5.classList.remove(styled.itemactive);
        }


    }



    function Atualiza(wclasse, wponto) {
        Remclasses();
        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(styled.itemactive);
        setScala(wponto)
    }

    function Avaliacao(wclasse, wponto) {
        RemclassesAvalia(wclasse);
        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(styled.itemactive);
        if (wclasse.substring(0, 9) == 'consultor') {
            setAvalia1(wponto);
        }
        if (wclasse.substring(0, 11) == 'assistencia') {
            setAvalia2(wponto);
        }
        if (wclasse.substring(0, 6) == 'canais') {
            setAvalia3(wponto);
        }
        if (wclasse.substring(0, 5) == 'setor') {
            setAvalia4(wponto);
        }
        if (wclasse.substring(0, 7) == 'entrega') {
            setAvalia5(wponto);
        }
    }


    return (
        <div className={styled.page}>
            <Menu menu="avaliacao" />
            <div className={styled.container}>
                <Header page="Avaliações" />
                <div className={styled.card}>
                    <div className={styled.cardheader}>
                        <div className={styled.cardtitle}>
                            <a>Avaliações</a>
                            <div className={styled.cardline}></div>
                        </div>
                    </div>
                    <div className={styled.cardcontent}>
                        <div className={styled.app}>
                            <div className={styled.framescala}>
                                <a>Em uma escala de 0 a 10, o quanto você recomendaria a Cozimax a um amigo ou colega?</a>
                                <div className={styled.scala}>
                                    <div id="a" className={styled.itemscala} onClick={() => Atualiza('a', 1)}>1</div>
                                    <div id="b" className={styled.itemscala} onClick={() => Atualiza('b', 2)}>2</div>
                                    <div id="c" className={styled.itemscala} onClick={() => Atualiza('c', 3)}>3</div>
                                    <div id="d" className={styled.itemscala} onClick={() => Atualiza('d', 4)}>4</div>
                                    <div id="e" className={styled.itemscala} onClick={() => Atualiza('e', 5)}>5</div>
                                    <div id="f" className={styled.itemscala} onClick={() => Atualiza('f', 6)}>6</div>
                                    <div id="g" className={styled.itemscala} onClick={() => Atualiza('g', 7)}>7</div>
                                    <div id="h" className={styled.itemscala} onClick={() => Atualiza('h', 8)}>8</div>
                                    <div id="i" className={styled.itemscala} onClick={() => Atualiza('i', 9)}>9</div>
                                    <div id="j" className={styled.itemscala} onClick={() => Atualiza('j', 10)}>10</div>
                                </div>
                            </div>
                            <div className={styled.areas}>
                                <a>Como você avalia a sua experiência com a Cozimax nas seguintes áreas:</a>
                                <div className={styled.areascontent}>
                                    <div className={styled.itemarea}>
                                        <div className={styled.itemtitulo}>
                                            <a>CONSULTOR/REPRESENTANTE</a>
                                        </div>
                                        <div className={styled.radio}>
                                            <div id="consultorvetor1" className={styled.itemradio} onClick={(e) => Avaliacao("consultorvetor1", 0)}>
                                                <div className={styled.vetor1}></div>
                                                <a>Insatisfeito</a>
                                            </div>
                                            <div id="consultorvetor2" className={styled.itemradio} onClick={(e) => Avaliacao("consultorvetor2", 1)}>
                                                <div className={styled.vetor2}></div>
                                                <a>Indiferente</a>
                                            </div>
                                            <div id="consultorvetor3" className={styled.itemradio} onClick={(e) => Avaliacao("consultorvetor3", 2)}>
                                                <div className={styled.vetor3}></div>
                                                <a>Satisfeito</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styled.itemarea}>
                                        <div className={styled.itemtitulo}>
                                            <a>ASSISTÊNCIA TÉCNICA</a>
                                        </div>
                                        <div className={styled.radio}>
                                            <div id="assistenciavetor1" className={styled.itemradio} onClick={(e) => Avaliacao("assistenciavetor1", 0)}>
                                                <div className={styled.vetor1}></div>
                                                <a>Insatisfeito</a>
                                            </div>
                                            <div id="assistenciavetor2" className={styled.itemradio} onClick={(e) => Avaliacao("assistenciavetor2", 1)}>
                                                <div className={styled.vetor2}></div>
                                                <a>Indiferente</a>
                                            </div>
                                            <div id="assistenciavetor3" className={styled.itemradio} onClick={(e) => Avaliacao("assistenciavetor3", 2)}>
                                                <div className={styled.vetor3}></div>
                                                <a>Satisfeito</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styled.itemarea}>
                                        <div className={styled.itemtitulo}>
                                            <a>CANAIS DE COMUNICAÇÃO</a>
                                        </div>
                                        <div className={styled.radio}>
                                            <div id="canaisvetor1" className={styled.itemradio} onClick={() => Avaliacao("canaisvetor1", 0)}>
                                                <div className={styled.vetor1}></div>
                                                <a>Insatisfeito</a>
                                            </div>
                                            <div id="canaisvetor2" className={styled.itemradio} onClick={() => Avaliacao("canaisvetor2", 1)}>
                                                <div className={styled.vetor2}></div>
                                                <a>Indiferente</a>
                                            </div>
                                            <div id="canaisvetor3" className={styled.itemradio} onClick={() => Avaliacao("canaisvetor3", 2)}>
                                                <div className={styled.vetor3}></div>
                                                <a>Satisfeito</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styled.itemarea}>
                                        <div className={styled.itemtitulo}>
                                            <a>SETORES INTERNOS</a>
                                        </div>
                                        <div className={styled.radio}>
                                            <div id="setorvetor1" className={styled.itemradio} onClick={() => Avaliacao("setorvetor1", 0)}>
                                                <div className={styled.vetor1}></div>
                                                <a>Insatisfeito</a>
                                            </div>
                                            <div id="setorvetor2" className={styled.itemradio} onClick={() => Avaliacao("setorvetor2", 1)}>
                                                <div className={styled.vetor2}></div>
                                                <a>Indiferente</a>
                                            </div>
                                            <div id="setorvetor3" className={styled.itemradio} onClick={() => Avaliacao("setorvetor3", 2)}>
                                                <div className={styled.vetor3}></div>
                                                <a>Satisfeito</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styled.itemarea}>
                                        <div className={styled.itemtitulo}>
                                            <a>ENTREGA</a>
                                        </div>
                                        <div className={styled.radio}>
                                            <div id="entregavetor1" className={styled.itemradio} onClick={() => Avaliacao("entregavetor1", 0)}>
                                                <div className={styled.vetor1}></div>
                                                <a>Insatisfeito</a>
                                            </div>
                                            <div id="entregavetor2" className={styled.itemradio} onClick={() => Avaliacao("entregavetor2", 1)}>
                                                <div className={styled.vetor2}></div>
                                                <a>Indiferente</a>
                                            </div>
                                            <div id="entregavetor3" className={styled.itemradio} onClick={() => Avaliacao("entregavetor3", 2)}>
                                                <div className={styled.vetor3}></div>
                                                <a>Satisfeito</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styled.melhorias}>
                                <a>O que poderíamos fazer para melhorar sua experiência de compra?</a>
                                <textarea value={melhoria} onChange={(e) => setMelhoria(e.target.value)} className={styled.fieldmelhoria}></textarea>
                            </div>
                            <div className={styled.nome}>
                                <a>Nome Completo <span>*</span></a>
                                <input type="text" value={nome} onChange={(e) => setNome(e.target.value)}></input>
                            </div>
                            <div className={styled.cargo}>
                                <a>Cargo atual <span>*</span></a>
                                <input type="text" value={cargo} onChange={(e) => setCargo(e.target.value)}></input>
                            </div>
                            <div className={styled.autorizo}>
                                <div className={styled.check}>
                                    <input id="check" type="checkbox" value={autoriza} onChange={() => handleCheck()}></input>
                                </div>
                                <div className={styled.desc}>
                                    <a>Autorizo o uso, por parte da COZIMAX, das informações fornecidas aqui.</a>
                                    <a href="https://www.cozimax.com.br/politica-de-privacidade/" target="_blank"><span>Ver política de privacidade</span> </a>
                                </div>

                            </div>
                            <div className={styled.btn} onClick={() => Salvar()}>ENVIAR RESPOSTAS</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Avaliacao;